"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startAndEndDateHelper = void 0;
var startAndEndDateHelper = function startAndEndDateHelper(startDate, endDate) {
  var hasOtherParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var leadingChar = hasOtherParams ? '&' : '?';
  if (startDate === '' && endDate === '') return '';
  if (!!startDate && !!endDate) return "".concat(leadingChar, "start=").concat(startDate, "&end=").concat(endDate);
  if (startDate) return "".concat(leadingChar, "start=").concat(startDate);
  if (endDate) return "".concat(leadingChar, "end=").concat(endDate);
  return '';
};
exports.startAndEndDateHelper = startAndEndDateHelper;